/* VB Fechas de envío — "Se envía el {fecha} • Envío gratis".
   {fecha} = siguiente día laborable (lun-vie) respecto a hoy; si la variante está
   sin stock real, se suman 5 días laborables más. Funciones puras testeables en Node. */
(function (global) {
  'use strict';

  var DIAS = ['dom.', 'lun.', 'mar.', 'mié.', 'jue.', 'vie.', 'sáb.'];

  // Suma n días laborables (lun-vie) a una fecha, sin mutar la original.
  function sumarLaborables(fecha, n) {
    var d = new Date(fecha.getTime());
    var restantes = n;
    while (restantes > 0) {
      d.setDate(d.getDate() + 1);
      var dow = d.getDay();
      if (dow !== 0 && dow !== 6) restantes--;
    }
    return d;
  }

  // Fecha de expedición: siguiente día laborable; sin stock => +5 laborables extra.
  function vbFechaEnvio(hoy, sinStock) {
    return sumarLaborables(hoy, 1 + (sinStock ? 5 : 0));
  }

  // "lun. 24/08"
  function vbFormatearFecha(d) {
    var dd = String(d.getDate());
    if (dd.length < 2) dd = '0' + dd;
    var mm = String(d.getMonth() + 1);
    if (mm.length < 2) mm = '0' + mm;
    return DIAS[d.getDay()] + ' ' + dd + '/' + mm;
  }

  global.vbFechaEnvio = vbFechaEnvio;
  global.vbFormatearFecha = vbFormatearFecha;

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { vbFechaEnvio: vbFechaEnvio, vbFormatearFecha: vbFormatearFecha, sumarLaborables: sumarLaborables };
    return;
  }

  if (typeof customElements !== 'undefined' && !customElements.get('vb-fechas-envio')) {
    var El = function () { return Reflect.construct(HTMLElement, [], El); };
    El.prototype = Object.create(HTMLElement.prototype);
    El.prototype.constructor = El;
    El.observedAttributes = ['data-oos'];
    El.prototype.render = function () {
      var oos = this.getAttribute('data-oos') === 'true';
      var out = this.querySelector('[data-vb-fechas-out]');
      if (out) out.textContent = vbFormatearFecha(vbFechaEnvio(new Date(), oos));
      this.hidden = false;
    };
    El.prototype.connectedCallback = El.prototype.render;
    El.prototype.attributeChangedCallback = El.prototype.render;
    Object.defineProperty(El, 'observedAttributes', { get: function () { return ['data-oos']; } });
    customElements.define('vb-fechas-envio', El);
  }
})(typeof window !== 'undefined' ? window : globalThis);
